import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'

import Field from '../../../../../../components/Form/Field'

import { formatOptionsList } from '../../../../../../features/formatters'

import {
  facebookClientAppsSelector,
  getFacebookClientAppsIsLoadingSelector
} from '../../../../../../modules/selectors/choices'

import { APPLICATION_ID } from './fields'

const AppListField = ({ formik, preselectFirstOptionValue = false }) => {
  const facebookClientApps = useSelector(facebookClientAppsSelector)
  const getFacebookClientAppsIsLoading = useSelector(getFacebookClientAppsIsLoadingSelector)

  const formattedClientApps = useMemo(
    () =>
      formatOptionsList({
        list: facebookClientApps,
        valueName: 'id',
        labelName: 'name'
      }),
    [facebookClientApps]
  )

  return (
    <Field
      name={APPLICATION_ID}
      formik={formik}
      placeholder="App Name"
      options={formattedClientApps}
      isLoading={getFacebookClientAppsIsLoading}
      preselectFirstOptionValue={preselectFirstOptionValue}
    />
  )
}

AppListField.propTypes = {
  formik: PropTypes.object.isRequired
}

export default AppListField
